import React from 'react';

import type { GameReturnDto } from '@skillarea/lib-shared';

import cx from 'classnames';

import { GameCard } from '../GameCard/GameCard';

import styles from './GamesSection.module.scss';

export interface IGamesSectionProps {
  gamesData?: { items: Record<number, GameReturnDto> };
  games?: GameReturnDto[];
  isLoading?: boolean;
  maxItems?: number;
  className?: string;
  gridClassName?: string;
}

export const GamesSection: React.FC<IGamesSectionProps> = ({
  className,
  games: gamesProp,
  gamesData,
  gridClassName,
  isLoading = false,
  maxItems = 4,
}) => {
  const games = gamesProp ?? (gamesData ? Object.values(gamesData.items) : []);
  const visibleGames = games.slice(0, maxItems);

  return (
    <div className={cx(styles.gamesGrid, className, gridClassName)}>
      {isLoading
        ? Array.from({ length: maxItems }).map((_, index) => (
            <div
              className={styles.gameCardSkeleton}
              key={`game-card-skeleton-${index}`}
            />
          ))
        : visibleGames.map((game) => <GameCard {...game} key={game.id} />)}
    </div>
  );
};
